import {Component, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DatePipe} from "@angular/common";
import {differenceInCalendarDays} from "date-fns";
import {ApiBaseService} from "../../../../../projects/vendors/src/lib/services/api-base.service";
import {StorageService} from "../../../../../projects/vendors/src/lib/services/storage.service";
import {RestaurantDetail, RestaurantDetailResponse} from "../../../@domain/resturant-detail";
import {ApiEnum} from "../../../@application/enum/api.enum";
import {DayEndTypes} from "../../../@application/enum/day-end-type";
import {DailySession} from "../../../@domain/daily-session";

@Component({
    selector: 'lib-day-end-dialog',
    templateUrl: './day-end-dialog.component.html',
    styleUrl: './day-end-dialog.component.css',
    standalone: false
})
export class DayEndDialogComponent implements OnInit {
  dayEndFrom!: FormGroup;
  private datePipe = inject(DatePipe)
  private apiBaseService = inject(ApiBaseService)
  private storageService = inject(StorageService)
  private dialogRef = inject(MatDialogRef<DayEndDialogComponent>)
  toDay = new Date()
  restaurantDetails = {} as RestaurantDetail

  data = inject<{dailySession: DailySession}>(MAT_DIALOG_DATA)

  ngOnInit() {
    this.formInit()
    this.restaurantDetails = this.storageService.getFromSessionStorage('restaurantDetail');
    if (this.restaurantDetails && this.restaurantDetails.dayEndInfo) {
      if (!this.restaurantDetails.dayEndInfo.endInSameDay && this.toDay){
        // If the restaurant is set to end day on next day, check if the current time is past the end time
        const endTimeParts = this.restaurantDetails.dayEndInfo.endTimeIn24H.split(':').map(Number);
        const nowHourAndMinutes = this.toDay.getHours() * 60 + this.toDay.getMinutes();
        const endHourAndMinutes = endTimeParts[0] * 60 + endTimeParts[1];
        if (nowHourAndMinutes >= endHourAndMinutes) {
          this.toDay.setDate(this.toDay.getDate()); // Move to tomorrow
        } else {
          this.toDay.setDate(this.toDay.getDate() - 1); // Keep today
        }
      }
      // this.setDefaultValues(this.toDay);
      this.setDefaultValues(new Date(this.data.dailySession.startTime));
    } else {
      this.getRestaurantDetail();
    }
  }

  private formInit() {
    this.dayEndFrom = new FormGroup({
      dayEndFor: new FormControl(this.data.dailySession.startTime, Validators.required),
      restaurantClosedTime: new FormControl(null, Validators.required),
      restaurantStartedTime: new FormControl(null, Validators.required),
      dayEndRemark: new FormControl(null),
      dayEndCashAmount: new FormControl(null, Validators.required),
      dayEndedType: new FormControl(DayEndTypes.Manual),
    })

    // this.dayEndFrom.get('dayEndFor')?.valueChanges.subscribe({
    //   next: value => {
    //     this.setDefaultValues(value)
    //   }
    // })
  }

  private setDefaultValues(currentDate: Date) {
    // this.dayEndFrom.get('dayEndFor')?.setValue(currentDate, { emitEvent: false });

    // const startTimeParts = this.restaurantDetails.dayEndInfo.startTimeIn24H.split(':').map(Number);
    // const startedTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), ...startTimeParts);
    // this.dayEndFrom.get('restaurantStartedTime')?.setValue(startedTime);
    this.dayEndFrom.get('restaurantStartedTime')?.setValue(this.data.dailySession.startTime)

    const endTimeParts = this.restaurantDetails.dayEndInfo.endTimeIn24H.split(':').map(Number);
    let closedTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), ...endTimeParts);

    if (!this.restaurantDetails.dayEndInfo.endInSameDay) {
      closedTime.setDate(closedTime.getDate() + 1);
    }

    this.dayEndFrom.get('restaurantClosedTime')?.setValue(closedTime);
  }

  disabledForDate = (startValue: Date): boolean => {
    if (!startValue) {
      return false;
    }
    // Allow selecting today or any date before today
    return differenceInCalendarDays(startValue, this.toDay) > 0;
  };

  disabledOpenDate = (startValue: Date): boolean => {
    const allowedDate = this.dayEndFrom.get('dayEndFor')?.value;

    // Disable all dates except the allowed date
    return !allowedDate || differenceInCalendarDays(startValue, allowedDate) !== 0;
  };

  disabledBeforeAndAfter = (startValue: Date): boolean => {
    const endValue = this.dayEndFrom.get('dayEndFor')?.value;

    if (!endValue) {
      return false;
    }

    // Disallow selecting dates before `dayEndFor` and after `dayEndFor + 1`
    return differenceInCalendarDays(startValue, endValue) < 0 || differenceInCalendarDays(startValue, endValue) > 1;
  };




  onSubmit() {
    if (this.dayEndFrom.valid) {
      const data = this.dayEndFrom.value
      data.dayEndFor = this.datePipe.transform(data.dayEndFor, 'yyyy-MM-dd')
      this.apiBaseService.UPDATE_API([ApiEnum.RestaurantModule,ApiEnum.DailySession, ApiEnum.End], this.dayEndFrom.value)
        .subscribe({
          next: () => {
            // the end endpoint returns 204, so the body carries nothing - close with an
            // explicit success flag, otherwise the caller can't tell success from cancel
            this.dialogRef.close(true)
          }
        })
    } else {
      Object.values(this.dayEndFrom.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({onlySelf: true})
        }
      })
    }
  }

  private getRestaurantDetail() {
    this.apiBaseService.GET<RestaurantDetailResponse>([ApiEnum.RestaurantModule, ApiEnum.SystemSetting,
      ApiEnum.RestaurantDetail])
      .subscribe({
        next: value => {
          if (value.restaurantDetail) {
            this.storageService.saveToSessionStorage('restaurantDetail', value.restaurantDetail);
            this.restaurantDetails = value.restaurantDetail;
            if (this.restaurantDetails.dayEndInfo) {
              this.setDefaultValues(this.toDay);
            }
          }
        }
      })
  }
}
